export default {
    tab: "wallet.tab",
    preset: "wallet.preset",
    bonuses: {
        update: "wallet.bonuses.update",
        toggleButton: "wallet.bonuses.toggleButton"
    },
    history: {
        add: "wallet.history.add",
        edit: "wallet.history.edit",
        loaded: "wallet.history.loaded",
        toggle: "wallet.history.toggle",
        toggleButton: "wallet.history.toggle.button"
    },
    crypto_deposit: {
        loaded: "wallet.crypto_deposit.loaded",
        change: "wallet.crypto_deposit.change"
    },
    cashapp_merchant_deposit: {
        setStage: "wallet.cashapp_merchant_deposit.stage",
        toggleStageButton: "wallet.cashapp_merchant_deposit.toggle.stage.button",
        updateStageData: "wallet.cashapp_merchant_deposit.update.stage.data",
        order: "wallet.cashapp_merchant_deposit.order",
    },
    applepay_deposit: {
        setStage: "wallet.applepay_deposit.stage",
        toggleStageButton: "wallet.applepay_deposit.toggle.stage.button",
        updateStageData: "wallet.applepay_deposit.update.stage.data",
        order: "wallet.applepay_deposit.order",
    },
    paypal_deposit: {
        setStage: "wallet.paypal_deposit.stage",
        toggleStageButton: "wallet.paypal_deposit.toggle.stage.button",
        updateStageData: "wallet.paypal_deposit.update.stage.data",
        order: "wallet.paypal_deposit.order",
    },
    googlepay_deposit: {
        setStage: "wallet.googlepay_deposit.stage",
        toggleStageButton: "wallet.googlepay_deposit.toggle.stage.button",
        updateStageData: "wallet.googlepay_deposit.update.stage.data",
        order: "wallet.googlepay_deposit.order",
    },
    cards_deposit: {
        setStage: "wallet.cards_deposit.stage",
        toggleStageButton: "wallet.cards_deposit.toggle.stage.button",
        updateStageData: "wallet.cards_deposit.update.stage.data",
        order: "wallet.cards_deposit.order",
    },
    zelle_deposit: {
        setStage: "wallet.zelle_deposit.stage",
        toggleStageButton: "wallet.zelle_deposit.toggle.stage.button",
        updateStageData: "wallet.zelle_deposit.update.stage.data",
        order: "wallet.zelle_deposit.order",
    },
    cashapp_p2p_deposit: {
        setStage: "wallet.cashapp_p2p_deposit.stage",
        toggleStageButton: "wallet.cashapp_p2p_deposit.toggle.stage.button",
        updateStageData: "wallet.cashapp_p2p_deposit.update.stage.data",
        order: "wallet.cashapp_p2p_deposit.order",
    },
    cashapp_deposit: {
        setStage: "wallet.cashapp_deposit.stage",
        toggleStageButton: "wallet.cashapp_deposit.toggle.stage.button",
        updateStageData: "wallet.cashapp_deposit.update.stage.data",
        order: "wallet.cashapp_deposit.order",
        initialize: "wallet.cashapp_deposit.initialize",
        clear: "wallet.cashapp_deposit.clear"
    },
    cashapp_cashout: {
        setStage: "wallet.cashapp_cashout.stage",
        toggleStageButton: "wallet.cashapp_cashout.toggle.stage.button",
        updateStageData: "wallet.cashapp_cashout.update.stage.data",
        order: "wallet.cashapp_cashout.order",
        initialize: "wallet.cashapp_cashout.initialize",
        clear: "wallet.cashapp_cashout.clear"
    },
    chime_deposit: {
        setStage: "wallet.chime_deposit.stage",
        toggleStageButton: "wallet.chime_deposit.toggle.stage.button",
        updateStageData: "wallet.chime_deposit.update.stage.data",
        order: "wallet.chime_deposit.order",
        initialize: "wallet.chime_deposit.initialize",
        clear: "wallet.chime_deposit.clear"
    },
    chime_cashout: {
        setStage: "wallet.chime_cashout.stage",
        toggleStageButton: "wallet.chime_cashout.toggle.stage.button",
        updateStageData: "wallet.chime_cashout.update.stage.data",
        order: "wallet.chime_cashout.order",
        initialize: "wallet.chime_cashout.initialize",
        clear: "wallet.chime_cashout.clear"
    }
}